var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"min-h-screen flex items-center justify-center bg-base-300"},[_c('div',{staticClass:"card bg-white rounded-xl p-5 max-w-sm text-center shadow"},[_c('p',{staticClass:"text-gray-600"},[_c('strong',[_vm._v(" Unauthorized Access ")]),_c('br'),_vm._v("Please try login using the link from your email. ")])])])
}]

export { render, staticRenderFns }